import { render, staticRenderFns } from "./AddNewDomain.vue?vue&type=template&id=f22dadfa&scoped=true&"
import script from "./AddNewDomain.vue?vue&type=script&lang=js&"
export * from "./AddNewDomain.vue?vue&type=script&lang=js&"
import style0 from "./AddNewDomain.vue?vue&type=style&index=0&id=f22dadfa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f22dadfa",
  null
  
)

export default component.exports